import React from "react";
import AppointmentForm from "../../AppointmentForm";
import { Icon } from "@iconify/react";

const contactInfo = [
  { 
    title: "Call Us", 
    subTitle: "+91-7770877117", 
    icon: "fa6-solid:phone" 
  },
  { 
    title: "Email Us", 
 subTitle: (
      <>
        jabalpur_1@pluro.in
        <br />
        fertilitycenterjbp@gmail.com
      </>
    ), 
    icon: "fa6-solid:envelope" 
  },


  {
    title: "Our Location",
    subTitle: "199-A, Pluro Jabalpur Fertility Centre, Opposite Madan Mahal Thana, Home Science College Road, Napier Town Jabalpur, 482001, Madhya Pradesh",
    icon: "fa6-solid:location-dot"
  },
];

export default function AppointmentWithContactInfoSection() {
  return (
    <div className="container cs_premium_appointments_wrapper">
      <div className="cs_premium_appointments_card">
        
        {/* Left Panel: Contact Information */}
        <div className="col-lg-4 col-md-12 cs_premium_appointments_sidebar">
          <h2 className="cs_sidebar_title">Get in Touch</h2>
          <p className="cs_sidebar_subtitle">
            We are here to assist you with any questions or concerns you may have about your fertility journey.
          </p>
          
          <div className="cs_contact_list">
            {contactInfo.map((item, index) => (
              <div className="cs_contact_item" key={index}>
                <div className="cs_icon_box">
                  <Icon icon={item.icon} />
                </div>
                <div className="cs_contact_text">
                  <h4>{item.title} </h4>
                  <p>{item.subTitle}</p> 
                </div>
              </div>
            ))}
          </div>

          <div className="cs_sidebar_image">
            <img
              src="/images/about/IMG_3267.JPG"
              alt="Clinic"
            />
          </div>
        </div>

        {/* Right Panel: Appointment Form */}
        <div className="col-lg-8 col-md-12 cs_premium_appointments_form">
          <div className="cs_form_header">
            <h2>Book Your Consultation</h2>
            <p>Take the first step towards your fertility goals. Fill out the form below.</p>
          </div>
          
          <AppointmentForm />
        </div>

      </div>
    </div>
  );
}
